
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/learning-mastery/jst/outcome-gradebook';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li>"
    + escapeExpression((helper = helpers.view || (depth0 && depth0.view),options={hash:{},data:data},helper ? helper.call(depth0, depth0, options) : helperMissing.call(depth0, "view", depth0, options)))
    + "</li>\n      ";
  return buffer;
  }

  buffer += "<div class=\"outcome-gradebook-sidebar\">\n  <div class=\"outcome-gradebook-sidebar-header\">\n    <a href=\"#\" class=\"icon-arrow-open-right sidebar-toggle\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("gradebook.outcome_gradebook")
  },data:data},helper ? helper.call(depth0, "gradebook.outcome_gradebook.toggle_sidebar", "Toggle Sidebar", options) : helperMissing.call(depth0, "t", "gradebook.outcome_gradebook.toggle_sidebar", "Toggle Sidebar", options)))
    + "</span>\n    </a>\n  </div>\n\n  <div class=\"outcome-gradebook-sidebar-content\">\n    <ul class=\"checkboxes unstyled\">\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.checkboxes), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n    <ul class=\"unstyled filters\">\n      <li>\n        <input type=\"checkbox\" id=\"no_results_outcomes\"/>\n        <label for=\"no_results_outcomes\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("gradebook.outcome_gradebook")
  },data:data},helper ? helper.call(depth0, "hide_outcomes_with_no_results_7e4ce06f", "Hide outcomes with no results", options) : helperMissing.call(depth0, "t", "hide_outcomes_with_no_results_7e4ce06f", "Hide outcomes with no results", options)))
    + "</label>\n      </li>\n    </ul>\n    <ul class=\"operations unstyled\" >\n      <li class=\"operation-view\">\n        <a href=\"#\" class=\"export-content icon-export-content\">\n          <span class=\"operation-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("gradebook.outcome_gradebook")
  },data:data},helper ? helper.call(depth0, "export_report_7c5899e", "Export report", options) : helperMissing.call(depth0, "t", "export_report_7c5899e", "Export report", options)))
    + "</span>\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<div class=\"outcome-gradebook-wrapper\"></div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  